<template>
  <section>
    <router-view :key="key"/>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed:{
    key(){
      return this.$route.path
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Layout/components/AppMain.vue